import React from 'react';

class ProductSubEditFeature extends React.Component {
   render() {
      return (
         <div>ProductSubEditFeature</div>
      );
   }
}

ProductSubEditFeature.propTypes = {};

export default ProductSubEditFeature;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditFeature.js
 **/